<template>
<div id="textarea-v1-65fr4r">
    <b-form-group id="textarea-v1-qe7uut" v-if="showType == 'form-builder'" :description="properties.description" :label="properties.label" :style="properties.style">
      <b-form-textarea id="textarea-v1-9jv3ln" :placeholder="properties.placeholder" :rows="properties.rows"></b-form-textarea>
    </b-form-group>
    <div id="textarea-v1-w5o7tq" v-if="showType == 'properties'">
      <textarea-v1-properties id="textarea-v1-9dx3ix" :formId="formId"></textarea-v1-properties>
    </div>
    <b-form-group id="textarea-v1-4gwl57" style="font-size: 14px" v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      " :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      " :style="properties.style" :hidden="computedHidden" :state="state" :invalid-feedback="errors.join(', ')">
      <template v-slot:label>
        <div id="textarea-v1-r033uk" class="d-flex justify-content-between align-items-center">
          <div id="textarea-v1-ga3k1u">
            {{ computedConditions.label
            ? computedPropertiesForm.label
            : properties.label }}
          </div>
          <div id="textarea-v1-sczyio" v-if="config.serverSegment == 'core'">
            <b-dropdown id="textarea-v1-5lepxf" text variant="link" size="sm" no-caret ref="responsesDropdown" boundary="viewport" right @show="getSavedResponses">
              <template #button-content>
                <i id="textarea-v1-95z7ob" class="fas fa-ellipsis-v text-secondary"></i>
              </template>
              <b-dropdown-form id="textarea-v1-yfpkfm">
                <div id="textarea-v1-m8zl28" v-if="currentFormId != 'previewForm'" class="dropdown-item hover-pointer" :disabled="!localValue" style="font-size: 14px;" @click="saveResponse"><i id="textarea-v1-x580gv" class="fas fa-save mr-2"></i>Save value</div>              
                <div id="textarea-v1-5lmyej" class="px-2" style="padding: 14px; font-size: 14px; background-color: #f4f7fb">
                  Load value:
                </div>
              </b-dropdown-form>
              <div class="dropdown-item hover-pointer" v-for="(s, i) in combinedResponses" :key="s.id" @click="writeResponse(s.response)" :id="'textarea-v1-sx5y3o-' + i">
                <div class="d-flex flex-row align-items-center justify-content-between" style="font-size: 14px;" :id="'textarea-v1-j0oo3x-' + i">                  
                  <div class="mr-3" style="white-space: normal" :id="'textarea-v1-3h5azu-' + i"><i class="fas fa-clone mr-2" :id="'textarea-v1-39eab4-' + i"></i>{{ s.response }}</div>
                  <i class="fas fa-trash text-danger" :style="{ visibility: s.isPredefined ? 'hidden' : 'visible' }" @click.stop="deleteResponse(s.id)" :id="'textarea-v1-ai0uf6-' + i"></i>
                </div>
              </div>
            </b-dropdown>
          </div>
        </div>
      </template>
      <b-form-textarea id="textarea-v1-z76zfa" style="font-size: 14px" :placeholder="
          computedConditions.placeholder
            ? computedPropertiesForm.placeholder
            : properties.placeholder
        " :readonly="
          computedConditions.readonly
            ? computedPropertiesForm.readonly
            : properties.readonly
        " :required="
          computedConditions.required
            ? computedPropertiesForm.required
            : properties.required
        " v-model="localValue" @blur="controlValue = localValue" :state="state" :rows="properties.rows" @input="autoGrow" :class="properties.autoHeight ? `textarea textarea_${this.id}` : ''"></b-form-textarea>
    </b-form-group>
    <b-form-group id="textarea-v1-chvdyz" v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      " :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      ">
      <p id="textarea-v1-ag8fqf" v-html-sanitize="controlValueFormatted"></p>
    </b-form-group>
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import TextareaV1Properties from "./TextareaV1Properties.vue";
import savedResponseServer from "../../../../server/userResponse";
import config from "../../../../server/serverCfg";
import { getComponentBaseId } from "../../../../helpers/formBuilder";

export default {
  name: "TextareaV1",
  components: {
    TextareaV1Properties
  },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: [
        "description",
        "label",
        "hidden",
        "placeholder",
        "readonly",
        "required",
        "responseOptions"
      ],
      computedConditions: {},
      localValue: "",
      savedResponses: [],
      config: config,
      savedResponsesLoaded: false
    };
  },
  mounted() {
    this.computeConditions();
    this.localValue = this.controlValue;
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      const baseId = getComponentBaseId(this.id);
      this.setFormSubmitterComponentMetadata({
        controlId: baseId,
        controlMetadata: {
          label: this.properties.label
        }
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: baseId,
          properties: this.properties
        });
      }
    }
    
    this.autoGrow();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true || this.properties.hideOnView)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group text-component" style="${this.getComponentComputedProperties(
        "style"
      )}">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <p style="font-size: 14px">${this.controlValueFormatted || ""}</p>
        </div>
      </fieldset>`;
    },
    async saveResponse(e) {
      if (this.currentFormId == "previewForm") return;
      e.stopPropagation()
      if(this.localValue.trim() && !this.combinedResponses.find(r => r.response.trim() == this.localValue.trim())) {
        await savedResponseServer.create({
          formId: this.currentFormId,
          componentId: this.id,
          response: this.localValue,
        });
        await this.getAllResponses();
        this.updatePopper();
      }
      
    },
    updatePopper() {
      this.$refs.responsesDropdown.updatePopper();
    },
    async deleteResponse(id){
      await savedResponseServer.delete(id);
      await this.getAllResponses();
      this.updatePopper();
    },
    async getAllResponses(){
      this.savedResponses = this.currentFormId == "previewForm" ? [] : await savedResponseServer.query(this.currentFormId, this.id);
    },
    writeResponse(response){
      this.controlValue = response;
    },
    autoGrow() {
      if(this.properties.autoHeight) {
        setTimeout(() => {
          const textarea = document.querySelector(`.textarea_${this.id}`);
          if (textarea) {
            var scrollHeight = textarea.scrollHeight;
            textarea.style.setProperty( 'height', scrollHeight + "px", 'important' );
            textarea.style.maxHeight = (scrollHeight + 50) + "px";
          }
        },0);        
      }
    },
    async getSavedResponses() {
      if (!this.savedResponsesLoaded) {
        await this.getAllResponses();
        this.savedResponsesLoaded = true;
      }
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentFormId: state => state.form.id,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
     computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValueFormatted() {
      return this.controlValue?.replaceAll("\n", "<br/>");
    },
    controlValue: {
      get() {
        const baseId = getComponentBaseId(this.id);
        let result = ""
        if (this.results) result = this.results[baseId];
        else result = this.getFormSubmitterComponentValue(baseId);
        this.autoGrow();
        return result;
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          const baseId = getComponentBaseId(this.id);
          this.setFormSubmitterComponentValue({
            controlId: baseId,
            controlValue: newControlValue,
            userAction: true,
            hardSet: this.properties.resetStoreValues
          });
          this.$emit("update-child-control-value", {
            controlId: baseId,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        const errorId = getComponentBaseId(this.id, this.formErrors);
        return this.formErrors[errorId] ? this.formErrors[errorId] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
   computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    },
    predefinedOptions() {
      const responseOptions = this.computedConditions.responseOptions
        ? this.computedPropertiesForm.responseOptions
        : this.properties.responseOptions;
      return responseOptions;
    },
    combinedResponses(){
      const predefinedOptions = this.predefinedOptions ?? [];
      return predefinedOptions.map(p => ({
          response: p,
          isPredefined: true
        })).concat(this.savedResponses);
    }
  },
  watch: {
    controlValue(newValue) {
      if (newValue != this.localValue) {
        this.localValue = newValue;
      }
    }
  }
};
</script>

<style scoped>
>>> .dropdown-menu {
  width: max-content;
  max-height: 300px;
  max-width: 500px;
  overflow-y: auto;
}

>>> .dropdown-item {
  padding: 0.25rem 0.5rem;
}

>>> .textarea {
    resize: none;
    overflow: hidden;
    height: 36px !important;
    max-height: 100px;
}
</style>
